var e=function(e){return function(n){for(var t=0,o=e.length;t<o&&!n.closed;t++)n.next(e[t]);n.complete()}};export{e as subscribeToArray};
